import api from "api/axios";

const BASE = "/admin/extraoral-findings";

export const getExtraoralFindings = (params) => api.get(BASE, { params });

export const createExtraoralFinding = (payload) => api.post(BASE, payload);

export const updateExtraoralFinding = (id, payload) =>
  api.put(`${BASE}/${id}`, payload);

export const deleteExtraoralFinding = (id) => api.delete(`${BASE}/${id}`);

export const importExtraoralFindings = (file) => {
  const body = new FormData();
  body.append("file", file);
  return api.post(`${BASE}/import`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const downloadExtraoralFindingFile = (kind, params) =>
  api.get(`${BASE}/${kind}`, { params, responseType: "blob" });
